import { render, staticRenderFns } from "./Observaciones.vue?vue&type=template&id=3c1014ae"
import script from "./Observaciones.vue?vue&type=script&lang=js"
export * from "./Observaciones.vue?vue&type=script&lang=js"
import style0 from "./Observaciones.vue?vue&type=style&index=0&id=3c1014ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports